import { api } from "@/lib/api";

export const REC = {
  strongly_recommend: ["Strongly recommend", "bg-success-tint text-success border-[#CADBCF]"],
  recommend: ["Recommend", "bg-teal-tint text-teal border-[#CBD8CF]"],
  consider: ["Consider", "bg-caution-tint text-caution border-[#E8D7B0]"],
  not_recommended: ["Not recommended", "bg-risk-tint text-risk border-[#E8C9C5]"],
};
export const CONF = { high: "High confidence", medium: "Medium confidence", low: "Low confidence" };
export const COMP_COLORS = { resume: "#1F4D3A", experience: "#3F7A5E", personality: "#35594A", work_sample: "#9A6700", interview: "#2B4C6F" };
export const COMP_LABELS = { resume: "Resume", experience: "Experience", personality: "Personality", work_sample: "Work sample", interview: "Interview", fit: "Fit Score" };
export const HRMS = { pending: "Processing", synced: "Completed", failed: "Failed", not_configured: "Ready" };
export const HRMS_LABEL = { pending: "Syncing", synced: "Synced", failed: "Failed", not_configured: "Ready to export" };
export const DECISION_LABEL = { hire: "Hired", hold: "On hold", reject: "Rejected" };
export const fmtFit = (v) => (v == null ? "—" : Number(v).toFixed(1));

export async function download(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
}
